<template>
  <div v-if="!isLoading" class="container-fluid new_Header">
    <nav class="nav_Breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item mx-3"><router-link  to="/">{{$t('propertielist.breadcrumb_1')}}</router-link></li>
        <i v-if="userLang == 'ar'" class="fa-solid fa-chevron-left pt-1"></i>
        <i v-else class="fa-solid fa-chevron-right pt-1"></i>
        <li class="active mx-2 almarai-bold" aria-current="page">
          {{$t('transferProject')}}
        </li>
      </ol>
    </nav>
  </div>
  <div class="container pt-3">
    <div class="text-center" v-if="isLoading">
      <mainloader />
    </div>
    <div v-else class="row">
      <div class="col">
        <div v-if="hasError">
          <errorAlert :alertMessage="message" :errorNumber='errorNumber' />
        </div>
        <div class="row">
          <div @click="setType(null)" :class="(sort == null)? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="all">
            <input class="form-check-input" type="radio" name="radioDefault" value="null" 
              v-model="purpose" id="all"
            >
              <span>{{$t("map.btnAll")}}</span>
            </label>
          </div>
          <div :class="(sort == 'asc')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="asc">
            <input class="form-check-input" type="radio" name="radioDefault" value="asc" 
              v-model="sort" id="asc" @change="exchangesList"
            >
              <span class="mx-2">{{$t('oldestNewest')}}</span>
            </label>
          </div>
          <div :class="(sort == 'desc')? 'col-auto categoryStyle balck-bg':'col-auto categoryStyle'">
            <label class="form-check-label mouse-hand" for="desc">
            <input class="form-check-input" type="radio" name="radioDefault" value="desc" 
              v-model="sort" id="desc" @change="exchangesList"
            >
              <span class="mx-2">{{$t('newestOldest')}}</span>
            </label>
          </div>
        </div>
        <div class="row pt-3">
          <div class="col-12 col-md-5 col-lg-3 mb-3" v-for="(val,index) in homeExchange" :key="index">
              <div class="card  card-border m-auto">
                <div class="card-body position-R">
                  <router-link :to="'/businessTransfer/'+val.id">
                    <!-- <div class="row statusBar">
                      <div class="col-auto tag-style">
                        <span class="">{{ val.PropertyType.name }}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{exchangeStatusChoices[val.status]}}</span>
                      </div>
                      <div class="col-auto tag-style">
                        <span class="">{{(val.purpose == 'for_rent') ? $t('rent') : (val.purpose == 'for_sale') ? $t('sale')  : $t('investment') }}</span>
                      </div>
                    </div> -->
                    <!-- <span class="heart-icon" v-if="val.Favorites && val.Favorites.length" @click.prevent="removeFavorite(val.id, 'singlesProperties', index)">
                      <i class="fa-solid fa-heart orange-Heart"></i>
                    </span>
                    <span  class="heart-icon" v-else @click.prevent="addFavorite(val.id, 'singlesProperties', index)">
                      <i class="fa-solid fa-heart heart"></i>
                    </span> -->
                    <swiper v-if="val.ExchangeMedia.length" class="text-center" 
                      :modules ="[Autoplay, Navigation, Pagination ]"
                      :autoplay ="{ delay: 2500,disableOnInteraction: false,}" 
                      :pagination ="{ clickable: true }" :navigation="false"
                    >
                      <swiper-slide v-for="(img, ind) in val.ExchangeMedia" :key="ind">
                        <img :src="MEDIA_URL+img.thumbnail" alt="Slide Image" class="w-100 br-radius" />
                      </swiper-slide>
                    </swiper>
                    <div v-else>
                      <placeHolder/>
                    </div>
                    <div class="text-title">{{ val.businessName }}</div>

                    <div class="row pt-1">
                      <div class="col-auto px-2 content-center">
                        <i class="fa-solid fa-location-dot gray-color"></i>
                      </div>
                      <div class="col p-0 fontGray-73 content-center">
                        <div class="d-flex">
                          {{ val.City?.name }}
                          <span class="mx-1">{{ val.Neighborhood?.name }}</span>
                        </div>
                      </div>
                    </div>
                  </router-link>
                  <hr class="border-color-w">
                  <div class="row end-card space mb-2">
                    <div class="col" v-if="val.price !=0">
                      <span class="mx-1 green-color-F icon-saudi_riyal_bold_new"></span>
                      <span class="green-color-F">{{ val.price }}</span>
                      <!-- <span class="mx-1 green-color-F">{{$t('currency')}}</span> -->
                    </div>

                    <div v-else class="col-6 col-md-7 content-center">
                      <div class="sendPrice" v-if="GET_USER">
                        <a :href="'https://wa.me/+966'+val.mobile +'?text=السلام عليكم وجدت إعلانكم في تطبيق عقار المحيسني وأرغب بالتواصل معكم بخصوص الإعلان:'" class="sendPriceLink" target="_blank">
                          <span class="mx-1 green-color-4C"><i class="fa-solid fa-circle-chevron-right verticalMiddle"></i></span>
                          {{$t('sendPrice')}}
                        </a>
                      </div>
                      <div @click="businessTransferPoup" class="sendPrice" v-if="!GET_USER">
                        <span class="mx-1 green-color-4C"><i class="fa-solid fa-circle-chevron-right verticalMiddle"></i></span>
                        {{$t('sendPrice')}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          </div>
        </div>

        <div v-if="!homeExchange.length"  class="row justify-content-center">
          <div class="col text-center">
            <div class="row justify-content-center">
              <div class="col-12 col-md-6 mb-3">
                <div class="card border-0 card-h">
                  <div class="card-body text-center">
                    <div><img src="/assets/images/icons/Frame_22.png" class="max-48" alt=""></div>
                    <div class="pt-2 almarai-bold font-22">
                      {{$t('home.title_7')}}
                    </div>
                    <div class="gray-color">{{$t('home.title_8')}}</div>
                    <div v-if="GET_USER" class="pt-3 m-auto w-75">
                      <router-link to="/propertyrequest">
                        <div class="form-control btn-green">{{$t('home.title_9')}}</div>
                      </router-link>
                    </div>
                    <div v-else class="pt-3 m-auto w-75">
                      <div @click="businessTransferPoup" class="form-control btn-green">{{t('home.title_9')}}</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row pt-5">
          <div class="col">
            <nav aria-label="Page navigation example">
              <ul class="pagination justify-content-center mouse-hand">
                <li class="page-item pagination-padding page-link br-radius4" v-if="currentPage > 1"  @click.prevent="prevPage">
                  <i class="fa-solid fa-circle-right orange-color mx-2"></i>
                  <span>{{$t('prev')}}</span>
                </li>
                <li class="page-item pagination-style">{{currentPage}}</li>
                <li class="page-item page-link pagination-padding br-radius4" v-if="homeExchange && homeExchange.length >= 30"  @click.prevent="nextPage">
                  <span class="mx-2">{{$t('next')}}</span>
                  <i class="fa-solid fa-circle-left orange-color"></i>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </div>
    </div>
    <!--begin:modal login-->
    <div class="modal bg-modal" dir="rtl" tabindex="-1" id="businessTransferLogin">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <div class="row">
              <div class="col">
                <div class="row">
                  <div class="col-auto mouse-hand" @click.prevent="closeBusinessTransfer">
                    <i class="fa-regular fa-circle-xmark fs-5 gray-color"></i>
                  </div>
                </div>
                <div class="row justify-content-center">
                  <div class="col text-center">
                    <div class="loginTitle">
                      {{$t("formLogin.title_1")}}
                    </div>
                    <p class="fontGray-73 mb-1 pt-1">
                      {{$t("formLogin.title_2")}} <br />
                      {{$t("formLogin.title_3")}}
                    </p>
                  </div>
                </div>
                <div class="row pt-3 justify-content-center">
                  <div class="col-12 col-md-8 mb-2">
                    <router-link to="/login">
                      <button
                        class="form-control btn-green"
                      >
                        {{$t("formLogin.title_4")}}
                      </button>
                    </router-link>
                  </div>
                  <div class="col-12 col-md-8 pt-1">
                    <router-link to="/register">
                      <button class="form-control btn-black">
                        {{ $t("formLogin.title_5") }}
                      </button>
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--end:modal Login-->
  </div>
</template>
<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import 'swiper/swiper-bundle.css';
</script>
<script>
import { mapGetters } from 'vuex';
// import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
// import { Pagination, Navigation, Autoplay } from "swiper/modules";
export default {
  name: "businessTransferList",
  // setup() {
  //   return {
  //     modules: [Pagination, Navigation, Autoplay]
  //   };
  // },
  data(){
    return{
      // propertyType: this.$route.query.propertyType,
      // typeId: this.$route.query.typeId,
      // regionID: this.$route.query.regionId,
      // cityId: this.$route.query.cityId,
      // neighborhoodId: this.$route.query.neighborhoodId,
      message: "",
      hasError: false,
      errorNumber: 0,
      isLoading: true,
      loading: true,
      value: {},
      currentPage: 1,
      purpo: "",
      regionId: "",
      city: "",
      neighborhood: "",
      regions: [],
      rows: [],
      items: [],
      types: [],
      loader: true,
      propertyType_Id: "",
      dataLoading: true,
      propertyTyp: "",
      age: 0,
      roomsCount: 0,
      floorNumber: 0,
      exchangeStatusChoices: {},
      homeExchange: [],
      userLang: 'ar',
      sort: null,
    }
  },
  components: { Swiper, SwiperSlide },
  computed: {
    ...mapGetters(['MEDIA_URL','GET_USER'])
  },
  methods:{
    exchangesList(){
      this.$http.get("/api/exchanges/list?page="+this.currentPage+'&'+'sort='+this.sort).then(res => {
        // console.log(res);
        this.homeExchange = res.data.rows;
        this.exchangeStatusChoices = res.data.statusChoices;
        this.isLoading = false;
      }).catch(err => {
        // console.log(err);
        this.isLoading = false;
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      })
    },

    citiesList(){
      this.hasError = false;
      this.$http.get("/api/cities/list?regionId="+this.regionId).then(res => {
        // console.log(res);
        this.rows = res.data.cities;
        this.loading = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    neighborhoodList(){
      this.hasError = false;
      this.$http.get("/api/neighborhoods/list?cityId="+this.city).then(res => {
        // console.log(res);
        this.items = res.data.neighborhoods;
        this.loader = false;
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    prevPage(){
      this.currentPage -= 1;
      this.exchangesList();
    },
    nextPage(){
      this.currentPage += 1;
      this.exchangesList();
    },

    removeItem(){
      // this.$router.push({name: 'propertielist'});
      // this.$router.replace({path : '/propertielist'})
      window.location.href = '/propertielist';
    },

    addFavorite(id, dataName, index){
      if(!this.GET_USER){
        document.getElementById('businessTransferLogin').style.display = "block";
        return false;
      }
      this.hasError = false;
      this.$http.post("/api/favorites/add",{
        propertyId: id,
      }).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
          this.value.properties[index].Favorites = [{}];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    removeFavorite(id, dataName, index){
      if(!this.GET_USER){
        document.getElementById('businessTransferLogin').style.display = "block";
        return false;
      }
      this.hasError = false;
      this.$http.delete("/api/favorites/remove/"+id).then(res => {
        // console.log(res);
        if(dataName == 'properties'){
          this.value.properties[index].Favorites = [];
        }
      }).catch(err => {
        // console.log(err);
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
      });
    },

    closeBusinessTransfer(){
      document.getElementById("businessTransferLogin").style.display = "none";
    },

    businessTransferPoup(){
      document.getElementById("businessTransferLogin").style.display = "block";
    },

    deleteImg(id, index){
      swal({
        title: this.$t('confirm_title'),
        // text: "You will not be able to recover this imaginary file!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: this.$t('confirmButtonText'),
        cancelButtonText: this.$t('cancelButtonText'),
        closeOnConfirm: false
      },()=> this.deleteMedia(id, index));
    },
    deleteMedia(id, index){
      this.hasError = false;
      this.$http.delete("/api/exchanges/delete/"+id).then(res => {
        this.homeExchange.splice(index, 1);
        swal(this.$t('confirmMessage'));
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scroll(0,0);
      })
    },
    setType(id){
      this.sort = id;
      this.exchangesList();
    },
  },

  created(){
    this.exchangesList();
    this.regionId = this.regionID;
    this.city = this.cityId;
    this.neighborhood = this.neighborhoodId;
    this.propertyType_Id = this.typeId;
    if(this.regionId){
      this.citiesList();
    }
    if(this.city){
      this.neighborhoodList();
    }
    this.userLang = localStorage.getItem('lang') ?? 'ar';
  },
}
</script>
